<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<v-row no-gutters justify="end">
				<v-btn @click="saveReport()" color="secondary">
					<v-icon class="mr-1"> mdi-content-save </v-icon>
					保存
				</v-btn>
			</v-row>
			<div class="mt-4">
				<table width="100%" class="show-dialog-table">
					<tbody>
						<template v-if="!$vuetify.breakpoint.xs">
							<tr>
								<th width="15%">工事名</th>
								<td width="35%">XXXXX</td>
								<th width="15%">製番</th>
								<td width="35%">XXXXX</td>
							</tr>
							<tr>
								<th width="15%">出張先</th>
								<td width="35%">XXXXX</td>
								<th width="15%">作業責任者</th>
								<td width="35%">XXXXX</td>
							</tr>
						</template>
						<template v-else>
							<tr>
								<th width="30%">工事名</th>
								<td width="70%">XXXXXX</td>
							</tr>
							<tr>
								<th width="30%">製番</th>
								<td width="70%">XXXXXX</td>
							</tr>
							<tr>
								<th width="30%">出張先</th>
								<td width="70%">XXXXXX</td>
							</tr>
							<tr>
								<th width="30%">作業責任者</th>
								<td width="70%">XXXXXX</td>
							</tr>
						</template>
					</tbody>
				</table>
			</div>
			<div class="mt-4">
				<v-row no-gutters>
					<v-col md="6" cols="12" class="pr-md-2">
						<div class="table-container">
							<table width="100%" class="show-dialog-table" :style="minWidth(450)">
								<tbody>
									<tr>
										<th width="45%" rowspan="2">移動日(行き)</th>
										<td width="25%">
											<v-select
												:items="homeOptions"
												item-text="name"
												item-value="id"
												v-model="TODO"
												dense
												outlined
												hide-details
											/>
										</td>
										<td width="5%">→</td>
										<td width="25%">
											<v-select
												:items="onSiteOptions"
												item-text="name"
												item-value="id"
												v-model="TODO"
												dense
												outlined
												hide-details
											/>
										</td>
									</tr>
									<tr>
										<td>
											<v-menu
												ref="menu"
												close-on-content-click
												transition="scale-transition"
												offset-y
												min-width="auto"
											>
												<template v-slot:activator="{ on, attrs }">
													<v-text-field
														v-model="TODO"
														outlined
														dense
														readonly
														hide-details
														v-bind="attrs"
														v-on="on"
													/>
												</template>
												<v-date-picker v-model="TODO" no-title scrollable locale="ja" />
											</v-menu>
										</td>
										<td>→</td>
										<td>
											<v-menu
												ref="menu"
												close-on-content-click
												transition="scale-transition"
												offset-y
												min-width="auto"
											>
												<template v-slot:activator="{ on, attrs }">
													<v-text-field
														v-model="TODO"
														outlined
														dense
														readonly
														hide-details
														v-bind="attrs"
														v-on="on"
													/>
												</template>
												<v-date-picker v-model="TODO" no-title scrollable locale="ja" />
											</v-menu>
										</td>
									</tr>
									<tr>
										<th rowspan="2">移動日(帰り)</th>
										<td>
											<v-select
												:items="onSiteOptions"
												item-text="name"
												item-value="id"
												v-model="TODO"
												dense
												outlined
												hide-details
											/>
										</td>
										<td>→</td>
										<td>
											<v-select
												:items="homeOptions"
												item-text="name"
												item-value="id"
												v-model="TODO"
												dense
												outlined
												hide-details
											/>
										</td>
									</tr>
									<tr>
										<td>
											<v-menu
												ref="menu"
												close-on-content-click
												transition="scale-transition"
												offset-y
												min-width="auto"
											>
												<template v-slot:activator="{ on, attrs }">
													<v-text-field
														v-model="TODO"
														outlined
														dense
														readonly
														hide-details
														v-bind="attrs"
														v-on="on"
													/>
												</template>
												<v-date-picker v-model="TODO" no-title scrollable locale="ja" />
											</v-menu>
										</td>
										<td>→</td>
										<td>
											<v-menu
												ref="menu"
												close-on-content-click
												transition="scale-transition"
												offset-y
												min-width="auto"
											>
												<template v-slot:activator="{ on, attrs }">
													<v-text-field
														v-model="TODO"
														outlined
														dense
														readonly
														hide-details
														v-bind="attrs"
														v-on="on"
													/>
												</template>
												<v-date-picker v-model="TODO" no-title scrollable locale="ja" />
											</v-menu>
										</td>
									</tr>
									<tr>
										<th width="45%">宿泊先名</th>
										<td width="55%" colspan="3">
											<v-text-field v-model="TODO" dense outlined hide-details />
										</td>
									</tr>
									<tr>
										<th width="45%">走行距離</th>
										<td width="55%" colspan="3">
											<v-text-field v-model="TODO" type="number" dense outlined hide-details />
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="table-container">
							<table width="100%" class="show-dialog-table" :style="minWidth(450)">
								<tbody>
									<tr>
										<th :rowspan="2" width="25%">移動工数</th>
										<th width="20%">社員</th>
										<td width="55%" colspan="2">
											<v-text-field v-model="TODO" type="number" dense outlined hide-details />
										</td>
									</tr>
									<tr>
										<th width="20%">協力会社</th>
										<td width="55%" colspan="2">
											<v-text-field v-model="TODO" type="number" dense outlined hide-details />
										</td>
									</tr>
									<tr>
										<th :rowspan="2" width="25%">移動時間</th>
										<th width="20%">社員</th>
										<td width="55%" colspan="2">
											<v-text-field v-model="TODO" type="number" dense outlined hide-details />
										</td>
									</tr>
									<tr>
										<th width="20%">協力会社</th>
										<td width="55%" colspan="2">
											<v-text-field v-model="TODO" type="number" dense outlined hide-details />
										</td>
									</tr>
									<tr>
										<th :rowspan="2" width="25%">宿泊</th>
										<th width="20%">社員</th>
										<td width="25%">
											<v-row no-gutters justify="space-between" class="flex-nowrap" align="center">
												<p>
													<v-text-field v-model="TODO" type="number" dense outlined hide-details />
												</p>
												<p class="pl-2">泊</p>
											</v-row>
										</td>
										<td width="30%">
											<v-row no-gutters justify="space-between" class="flex-nowrap" align="center">
												<p>
													<v-text-field v-model="TODO" type="number" dense outlined hide-details />
												</p>
												<p class="pl-2">円</p>
											</v-row>
										</td>
									</tr>
									<tr>
										<th width="20%">協力会社</th>
										<td width="25%">
											<v-row no-gutters justify="space-between" class="flex-nowrap" align="center">
												<p>
													<v-text-field v-model="TODO" type="number" dense outlined hide-details />
												</p>
												<p class="pl-2">泊</p>
											</v-row>
										</td>
										<td width="30%">
											<v-row no-gutters justify="space-between" class="flex-nowrap" align="center">
												<p>
													<v-text-field v-model="TODO" type="number" dense outlined hide-details />
												</p>
												<p class="pl-2">円</p>
											</v-row>
										</td>
									</tr>
									<tr>
										<th :rowspan="2" width="25%">作業工数</th>
										<th width="20%">社員</th>
										<td width="55%" colspan="2">
											<v-text-field v-model="TODO" type="number" dense outlined hide-details />
										</td>
									</tr>
									<tr>
										<th width="20%">協力会社</th>
										<td width="55%" colspan="2">
											<v-text-field v-model="TODO" type="number" dense outlined hide-details />
										</td>
									</tr>
									<tr>
										<th :rowspan="2" width="25%">残業時間</th>
										<th width="20%">社員</th>
										<td width="55%" colspan="2">
											<v-text-field v-model="TODO" type="number" dense outlined hide-details />
										</td>
									</tr>
									<tr>
										<th width="20%">協力会社</th>
										<td width="55%" colspan="2">
											<v-text-field v-model="TODO" type="number" dense outlined hide-details />
										</td>
									</tr>
									<tr>
										<th :rowspan="2" width="25%">休日出勤</th>
										<th width="20%">社員</th>
										<td width="55%" colspan="2">
											<v-text-field v-model="TODO" type="number" dense outlined hide-details />
										</td>
									</tr>
									<tr>
										<th width="20%">協力会社</th>
										<td width="55%" colspan="2">
											<v-text-field v-model="TODO" type="number" dense outlined hide-details />
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</v-col>
					<v-col md="6" cols="12" class="pl-md-2">
						<div class="table-container">
							<table width="100%" class="show-dialog-table" :style="minWidth(400)">
								<tbody>
									<tr>
										<th width="55%" colspan="3">交通便</th>
										<td width="45%"><v-text-field v-model="TODO" dense outlined hide-details /></td>
									</tr>
									<tr>
										<th width="55%" colspan="3">社有車台数</th>
										<td width="45%"><v-text-field v-model="TODO" dense outlined hide-details /></td>
									</tr>
									<tr>
										<th width="55%" colspan="3">社有車ナンバー</th>
										<td width="45%"><v-text-field v-model="TODO" dense outlined hide-details /></td>
									</tr>
									<tr>
										<th width="20%" rowspan="11">交通費</th>
										<th width="35%" colspan="2">電車</th>
										<td width="45%"><v-text-field v-model="TODO" dense outlined hide-details /></td>
									</tr>
									<tr>
										<th width="35%" colspan="2">飛行機</th>
										<td width="45%"><v-text-field v-model="TODO" dense outlined hide-details /></td>
									</tr>
									<tr>
										<th width="35%" colspan="2">船</th>
										<td width="45%"><v-text-field v-model="TODO" dense outlined hide-details /></td>
									</tr>
									<tr>
										<th width="35%" colspan="2">現地レンタカー</th>
										<td width="45%"><v-text-field v-model="TODO" dense outlined hide-details /></td>
									</tr>
									<tr>
										<th width="35%" colspan="2">タクシー</th>
										<td width="45%"><v-text-field v-model="TODO" dense outlined hide-details /></td>
									</tr>
									<tr>
										<th width="35%" colspan="2">リース費</th>
										<td width="45%"><v-text-field v-model="TODO" dense outlined hide-details /></td>
									</tr>
									<tr>
										<th width="35%" colspan="2">ガソリン代</th>
										<td width="45%"><v-text-field v-model="TODO" dense outlined hide-details /></td>
									</tr>
									<tr>
										<th width="35%" colspan="2">軽油代</th>
										<td width="45%"><v-text-field v-model="TODO" dense outlined hide-details /></td>
									</tr>
									<tr>
										<th width="35%" colspan="2">高速代</th>
										<td width="45%"><v-text-field v-model="TODO" dense outlined hide-details /></td>
									</tr>
									<tr>
										<th width="35%" colspan="2">下請け交通費</th>
										<td width="45%"><v-text-field v-model="TODO" dense outlined hide-details /></td>
									</tr>
									<tr>
										<th width="15%">その他</th>
										<th width="20%"><v-text-field v-model="TODO" dense outlined hide-details background-color="white" /></th>
										<td width="45%"><v-text-field v-model="TODO" dense outlined hide-details /></td>
									</tr>
									<tr>
										<th width="25%">その他代</th>
										<th width="30%" colspan="2">宅急便代</th>
										<td width="45%"><v-text-field v-model="TODO" dense outlined hide-details /></td>
									</tr>
									<tr>
										<th width="55%" colspan="3">合計</th>
										<td width="45%">XXXXXXX</td>
									</tr>
								</tbody>
							</table>
						</div>
					</v-col>

					<v-col cols="12">
						<v-sheet elevation="0" class="mt-4">
							<div class="table-container">
								<table width="100%" class="show-dialog-table" :style="minWidth(450)">
									<tbody>
										<tr>
											<th width="20%">ロットNo.</th>
											<th width="30%">名称・材料</th>
											<th width="15%">規格</th>
											<th width="15%">単位</th>
											<th width="20%">戻り数量</th>
										</tr>
										<tr v-for="n of 2" :key="n">
											<td>XXXX</td>
											<td>XXXXXXX</td>
											<td>XX</td>
											<td>XX</td>
											<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
										</tr>
									</tbody>
								</table>
							</div>
						</v-sheet>
						<v-sheet elevation="0" class="mt-4">
							<div class="table-container">
								<table width="100%" class="show-dialog-table" :style="minWidth(490)">
									<tbody>
										<tr>
											<th width="30%">消耗品</th>
											<th width="25%">規格</th>
											<th width="15%">単位</th>
											<th width="15%">追加数量</th>
											<th width="15%">戻り数量</th>
										</tr>
										<tr v-for="n of 2" :key="n">
											<td>XXXXXXX</td>
											<td>XXXXX</td>
											<td>XX</td>
											<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
											<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
										</tr>
									</tbody>
								</table>
							</div>
						</v-sheet>
						<v-sheet elevation="0" class="mt-4">
							<div class="table-container">
								<table width="100%" class="show-dialog-table" :style="minWidth(500)">
									<tbody>
										<tr>
											<th width="45%" colspan="2">一般工具類等</th>
											<th width="15%">規格</th>
											<th width="15%">単位</th>
											<th width="15%">戻り数量</th>
										</tr>
										<tr v-for="(tool, i) in layoutSample.tools" :key="i">
											<td width="20%">{{ tool.name }}</td>
											<td width="35%">XXXX</td>
											<td>XX</td>
											<td>XX</td>
											<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
										</tr>
									</tbody>
								</table>
							</div>
						</v-sheet>
						<v-sheet elevation="0" class="mt-4">
							<div class="table-container">
								<table width="100%" class="show-dialog-table" :style="minWidth(550)">
									<tbody>
										<tr>
											<th width="30%">リース品</th>
											<th width="20%">仕様</th>
											<th width="10%">数量</th>
											<th width="10%">日数</th>
											<th width="10%">運送費</th>
											<th width="10%">燃料(軽油)(L)</th>
											<th width="10%">産廃費</th>
										</tr>
										<tr v-for="n of 2" :key="n">
											<td>XXXXXXX</td>
											<td>XXXX</td>
											<td>XX</td>
											<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
											<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
											<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
											<td><v-text-field v-model="TODO" dense outlined hide-details /></td>
										</tr>
									</tbody>
								</table>
							</div>
						</v-sheet>
					</v-col>
				</v-row>
			</div>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import ConstructionMaterialAddDialog from "./components/ConstructionMaterialAddDialog.vue"

export default {
	components: {
		CommonFlame,
		ConstructionMaterialAddDialog,
	},
	data() {
		return {
			title: "報告書入力",
			id: this.$route.params.id,
			TODO: null,
			homeOptions: [
				{ id: "home", name: "自宅" },
				{ id: "company", name: "会社" },
			],
			onSiteOptions: [
				{ id: "on_site", name: "現地" },
				{ id: "hotel", name: "宿" },
			],
			categories: [
				{ name: "材料", id: "materials" },
				{ name: "検査機器類", id: "inspection_instruments" },
				{ name: "消耗品", id: "consumption_articles" },
				{ name: "一般工具類等", id: "tools" },
				{ name: "リース品", id: "lease_products" },
			], // 仮 DB から取得の可能性あり
			addDialog: false,
			selectedCategory: null,
			common,
		}
	},

	mounted() {
		// this.fetchConstructionReport()
	},
	methods: {
		fetchConstructionReport() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/constructions/construction_reports/${this.id}/edit`
			axios
				.get(url, {
					headers,
				})
				.then((res) => {
					// TODO
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		saveReport() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/constructions/construction_reports/${this.id}`
			const params = {}
			axios
				.put(url, params, {
					headers,
				})
				.then((res) => {
					// TODO
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openAddDialog(category) {
			this.selectedCategory = category
			this.addDialog = true
		},
		addItem(category, item) {
			this[category].push(item)
		},
		minWidth(num) {
			return { "min-width": num + "px" }
		},
	},
	computed: {
		layoutSample() {
			return {
				tools: [{ name: "電工工具" }, { name: "エア工具" }, { name: "他" }],
			}
		},
	},
}
</script>

<style lang="scss" scoped>
th {
	background-color: whitesmoke;
	border-right: 1px solid white;
	font-weight: bold;
	padding: 4px;
}
td {
	border-bottom: 1px solid whitesmoke;
	padding: 4px;
	border-right: 1px solid whitesmoke;
	&:first-child {
		border-left: 1px solid whitesmoke;
	}
}
</style>